import React from "react";
import "./Navbar.css";
import { useNavigate } from "react-router-dom";

export const Navbar = () => {
	const navigate = useNavigate();

	return (
		<header className="nav">
			<div className="nav-brand" onClick={() => navigate("/")}>
				<div className="nav-emblem">
					<img
						src="/image.png"
						alt="Government of Tamil Nadu"
					/>
				</div>
				<div className="nav-titles">
					<span className="nav-title">TNGASA</span>
					<span className="nav-sub">College Admissions</span>
				</div>
			</div>
		</header>
	);
};
